<template>
    <div class="content__inner" v-if="!loading">
        <keep-alive>
            <component :is="viewComponent" :id="id" />
        </keep-alive>
    </div>
</template>

<script>
import ChemicalManager from './ChemicalManager';
import FertiliserManager from './FertiliserManager';
import PurchaseHistoryManager from './PurchaseHistoryManager';
import PurchaseInputManager from './PurchaseInputManager';
import StockOnHandManager from './StockOnHandManager';


export default {
  name: 'StockManager',
  components: {
    StockOnHandManager,
    PurchaseInputManager,
    PurchaseHistoryManager,
    FertiliserManager,
    ChemicalManager,
  },
  apollo: {},
  computed: {
    viewComponent() {
      switch (this.view) {
        case 'purchase-input':
          return PurchaseInputManager;
        case 'purchase-history':
          return PurchaseHistoryManager;
        case 'chemicals':
          return ChemicalManager;
        case 'fertilisers':
          return FertiliserManager;
        default:
          return StockOnHandManager;
      }
    },
  },
  props: {
    view: {
      type: String,
      default: 'stock-on-hand',
    },
    id: {
    },
  },
  data() {
    return {
      loading: 0,
    };
  },
  methods: {
    changeView(view) {
      this.$router.push({ name: 'stock-management', params: { view } });
    },

  },
};
</script>
